import { render, staticRenderFns } from "./ArmsBaseArchiveFilingReference.vue?vue&type=template&id=79dfab15&scoped=true&"
import script from "./ArmsBaseArchiveFilingReference.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseArchiveFilingReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfab15",
  null
  
)

export default component.exports